import React, { useContext } from 'react';

import { DeprecatedDateRangeDropdown } from '../../../../../../../components/date-range-dropdown-deprecated';
import options from '../../../../../../../components/date-range-dropdown-deprecated/date-range-options';
import { ReportsContext } from '../../../context';
import style from '../../style.module.less';

const DateRange = () => {
  const { setDateRange, startDate, endDate } = useContext(ReportsContext);
  const lastWeekOperatorObject = options[2];

  return (
    <DeprecatedDateRangeDropdown
      dateRangeOptions={options}
      dropdownTogglerClassname={style['dropdown-toggler']}
      endCustomDate={endDate}
      selectedOption={lastWeekOperatorObject}
      setDateRange={setDateRange}
      startCustomDate={startDate}
    />
  );
};

export default DateRange;
